import CNPJValidator from './CNPJValidator'

function removeSpecialCharacters(str) {
    // Regular expression to capture all special characters
    const regex = /[^\w]/g

    // Replaces all special characters with an empty string
    return str.replace(regex, '')
}

export {
    CNPJValidator,
    removeSpecialCharacters
}